import { render, staticRenderFns } from "./CreateCampaignCloseModal.vue?vue&type=template&id=19798769&scoped=true"
import script from "./CreateCampaignCloseModal.vue?vue&type=script&lang=js"
export * from "./CreateCampaignCloseModal.vue?vue&type=script&lang=js"
import style0 from "./CreateCampaignCloseModal.vue?vue&type=style&index=0&id=19798769&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19798769",
  null
  
)

export default component.exports